// ImmoWerte24 Shopify Theme JS

// ── Navigation scroll effect ──
(function () {
  var nav = document.getElementById('main-nav');
  if (!nav) return;
  window.addEventListener('scroll', function () {
    if (window.scrollY > 30) {
      nav.style.padding = '0.75rem 0';
      nav.style.boxShadow = '0 2px 20px rgba(0,0,0,.08)';
    } else {
      nav.style.padding = '1.25rem 0';
      nav.style.boxShadow = 'none';
    }
  }, { passive: true });
})();

// ── Smooth scroll for anchor links ──
document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
  anchor.addEventListener('click', function (e) {
    var id = this.getAttribute('href').slice(1);
    var target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// ── AfA Calculator (full section) ──
(function () {
  var kaufpreisEl      = document.getElementById('kaufpreis');
  var gebaeudeanteilEl = document.getElementById('gebaeudeanteil');
  var baujahrEl        = document.getElementById('baujahr');
  var steuersatzEl     = document.getElementById('steuersatz');
  if (!kaufpreisEl) return;

  function fmt(n) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);
  }
  function update() {
    var kaufpreis      = parseInt(kaufpreisEl.value);
    var gebaeudeanteil = parseInt(gebaeudeanteilEl.value);
    var rnd            = parseInt(baujahrEl.value);
    var steuersatz     = parseInt(steuersatzEl.value);
    document.getElementById('kaufpreis-display').textContent       = fmt(kaufpreis);
    document.getElementById('gebaeudeanteil-display').textContent  = gebaeudeanteil + ' %';
    document.getElementById('steuersatz-display').textContent      = steuersatz + ' %';
    var gebaeudewert    = kaufpreis * (gebaeudeanteil / 100);
    var jaehrlicheAfA   = gebaeudewert / rnd;
    var steuerersparnis = jaehrlicheAfA * (steuersatz / 100);
    var zehnJahre       = steuerersparnis * 10;
    document.getElementById('r-gebaeudewert').textContent = fmt(gebaeudewert);
    document.getElementById('r-afa').textContent          = fmt(jaehrlicheAfA);
    document.getElementById('r-ersparnis').textContent    = fmt(steuerersparnis);
    document.getElementById('r-zehn').textContent         = fmt(zehnJahre);
  }
  kaufpreisEl.addEventListener('input', update);
  gebaeudeanteilEl.addEventListener('input', update);
  baujahrEl.addEventListener('change', update);
  steuersatzEl.addEventListener('input', update);
  update();
})();

// ── AfA Mini-Rechner (in Produktkarte) ──
(function () {
  var toggleBtn   = document.getElementById('afa-calc-toggle');
  var miniCalc    = document.getElementById('afa-mini-calc');
  var mcKaufpreis = document.getElementById('mc-kaufpreis');
  var mcGebant    = document.getElementById('mc-gebaeudeanteil');
  var mcBaujahr   = document.getElementById('mc-baujahr');
  var mcSteuer    = document.getElementById('mc-steuersatz');
  if (!toggleBtn || !miniCalc || !mcKaufpreis) return;

  toggleBtn.addEventListener('click', function () {
    var open = miniCalc.hidden;
    miniCalc.hidden = !open;
    toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var arrow = toggleBtn.querySelector('.card__mini-calc-arrow');
    if (arrow) arrow.textContent = open ? '▴' : '▾';
  });

  function fmt(n) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);
  }
  function updateMini() {
    var kaufpreis      = parseInt(mcKaufpreis.value);
    var gebaeudeanteil = parseInt(mcGebant.value);
    var rnd            = parseInt(mcBaujahr.value);
    var steuersatz     = parseInt(mcSteuer.value);
    document.getElementById('mc-kaufpreis-display').textContent      = fmt(kaufpreis);
    document.getElementById('mc-gebaeudeanteil-display').textContent = gebaeudeanteil + ' %';
    document.getElementById('mc-steuersatz-display').textContent     = steuersatz + ' %';
    var gebaeudewert    = kaufpreis * (gebaeudeanteil / 100);
    var jaehrlicheAfA   = gebaeudewert / rnd;
    var steuerersparnis = jaehrlicheAfA * (steuersatz / 100);
    document.getElementById('mc-r-ersparnis').textContent = fmt(steuerersparnis);
    document.getElementById('mc-r-zehn').textContent      = fmt(steuerersparnis * 10);
  }
  mcKaufpreis.addEventListener('input', updateMini);
  mcGebant.addEventListener('input', updateMini);
  mcBaujahr.addEventListener('change', updateMini);
  mcSteuer.addEventListener('input', updateMini);
  updateMini();
})();

// ── Immobilien-Formular Modal ──
(function () {
  var modal         = document.getElementById('order-modal');
  var form          = document.getElementById('order-form');
  var varIdEl       = document.getElementById('modal-variant-id');
  var prodTitleEl   = document.getElementById('modal-product-title');
  var prodTypeEl    = document.getElementById('modal-product-type');
  var prodNameSpan  = document.getElementById('modal-product-name');
  var errorEl       = document.getElementById('order-form-error');
  var submitBtn     = document.getElementById('modal-submit');
  var submitText    = document.getElementById('modal-submit-text');
  var submitLoad    = document.getElementById('modal-submit-loading');
  var dropzone      = document.getElementById('file-dropzone');
  var fileInput     = document.getElementById('file-input');
  var fileList      = document.getElementById('file-list');
  if (!modal) return;

  var selectedFiles = [];

  // ── File handling ──
  function formatSize(bytes) {
    if (bytes < 1024)    return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(0) + ' KB';
    return (bytes / 1048576).toFixed(1) + ' MB';
  }
  function renderFileList() {
    if (selectedFiles.length === 0) { fileList.hidden = true; return; }
    fileList.hidden = false;
    fileList.innerHTML = selectedFiles.map(function (f, i) {
      return '<div class="mform__file-item">' +
        '<span class="mform__file-name">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>' +
          f.name + '<span class="mform__file-size">' + formatSize(f.size) + '</span>' +
        '</span>' +
        '<button type="button" class="mform__file-remove" data-idx="' + i + '" title="Entfernen">\u2715</button>' +
      '</div>';
    }).join('');
    fileList.querySelectorAll('.mform__file-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectedFiles.splice(parseInt(this.dataset.idx), 1);
        renderFileList();
      });
    });
  }
  function addFiles(files) {
    Array.from(files).forEach(function (f) {
      if (f.size > 20 * 1024 * 1024) { alert('Die Datei "' + f.name + '" ist größer als 20 MB.'); return; }
      if (!selectedFiles.some(function (ef) { return ef.name === f.name && ef.size === f.size; })) selectedFiles.push(f);
    });
    renderFileList();
  }
  if (fileInput) fileInput.addEventListener('change', function () { addFiles(this.files); });
  if (dropzone) {
    dropzone.addEventListener('click', function (e) { if (e.target.tagName !== 'LABEL') fileInput.click(); });
    dropzone.addEventListener('dragover', function (e) { e.preventDefault(); this.classList.add('dragover'); });
    dropzone.addEventListener('dragleave', function () { this.classList.remove('dragover'); });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault(); this.classList.remove('dragover');
      if (e.dataTransfer.files.length) addFiles(e.dataTransfer.files);
    });
  }

  // ── Product-type field visibility ──
  function setProductType(type) {
    if (prodTypeEl) prodTypeEl.value = type;

    // Show/hide conditional sections
    modal.querySelectorAll('[data-product-types]').forEach(function (el) {
      var types = el.dataset.productTypes.split(',');
      el.hidden = !types.includes(type);
    });

    // Required-field management for conditional sections
    // AfA-specific required fields
    var vollgeschosseEl = document.getElementById('f-vollgeschosse');
    var stichtagEl      = document.getElementById('f-stichtag');
    if (vollgeschosseEl) vollgeschosseEl.required = (type === 'afa');
    if (stichtagEl)      stichtagEl.required      = (type === 'afa');

    // Date constraints for Wertermittlungsstichtag (max 4 years back)
    if (stichtagEl) {
      var today   = new Date();
      var minDate = new Date(today.getFullYear() - 4, today.getMonth(), today.getDate());
      stichtagEl.max = today.toISOString().split('T')[0];
      stichtagEl.min = minDate.toISOString().split('T')[0];
    }

    // Zweck required for schnellwert
    var zweckSw = document.getElementById('f-zweck-sw');
    if (zweckSw) zweckSw.required = (type === 'schnellwert');

    // Zweck + Zustand required for immogutachten
    var zweckIg  = document.getElementById('f-zweck-ig');
    var zustandEl = document.getElementById('f-zustand');
    if (zweckIg)   zweckIg.required   = (type === 'immogutachten');
    if (zustandEl) zustandEl.required = (type === 'immogutachten');

    // Zweck required for verkehrswert
    var zweckVw = document.getElementById('f-zweck-vw');
    if (zweckVw) zweckVw.required = (type === 'verkehrswert');

    // Label change: "Immobilienart" vs "Objekttyp" for AfA
    var artLabel = document.getElementById('f-art-label');
    if (artLabel) artLabel.textContent = (type === 'afa') ? 'Objekttyp (Gebäudeart) *' : 'Art der Immobilie *';

    // Verkehrswert: show/hide notices
    var noticeVerkehr  = document.getElementById('modal-notice-verkehrswert');
    var noticeStandard = document.getElementById('modal-notice-standard');
    if (noticeVerkehr)  noticeVerkehr.hidden  = (type !== 'verkehrswert');
    if (noticeStandard) noticeStandard.hidden = (type === 'verkehrswert');

    // Verkehrswert: change submit button label
    if (submitText) {
      submitText.textContent = (type === 'verkehrswert') ? 'Anfrage absenden' : 'Weiter zur Kasse';
    }
  }

  // ── Modal open / close ──
  function openModal(variantId, productTitle, productType) {
    if (varIdEl)     varIdEl.value     = variantId  || '';
    if (prodTitleEl) prodTitleEl.value = productTitle || '';
    if (prodNameSpan) prodNameSpan.textContent = productTitle || 'Gutachten';
    setProductType(productType || 'schnellwert');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var first = modal.querySelector('input:not([type=hidden]):not([type=file]), select');
      if (first) first.focus();
    }, 50);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    form.reset();
    selectedFiles = [];
    renderFileList();
    errorEl.hidden = true;
    setLoading(false);
    form.querySelectorAll('.error').forEach(function (el) { el.classList.remove('error'); });
  }

  function setLoading(on) {
    submitBtn.disabled = on;
    submitText.hidden  = on;
    submitLoad.hidden  = !on;
  }

  document.querySelectorAll('.open-order-modal').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openModal(this.dataset.variantId, this.dataset.productTitle, this.dataset.productType);
    });
  });

  modal.querySelector('.modal__backdrop').addEventListener('click', closeModal);
  document.getElementById('modal-close').addEventListener('click', closeModal);
  document.getElementById('modal-cancel').addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // ── Form submit ──
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;

    // Validate only visible required fields
    var valid = true;
    form.querySelectorAll('[required]').forEach(function (el) {
      el.classList.remove('error');
      // Skip if inside a hidden section
      var section = el.closest('[data-product-types]');
      if (section && section.hidden) return;
      if (!el.value.trim()) { el.classList.add('error'); valid = false; }
    });
    if (!valid) {
      errorEl.textContent = 'Bitte füllen Sie alle Pflichtfelder (mit *) aus.';
      errorEl.hidden = false;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }

    setLoading(true);

    var type = (prodTypeEl && prodTypeEl.value) ? prodTypeEl.value : 'schnellwert';

    // Collect line item properties
    var properties = {};
    new FormData(form).forEach(function (value, key) {
      if (['variant_id', 'product_title', 'product_type'].includes(key)) return;
      if (key === 'Unterlagen_fehlen') {
        properties['Unterlagen vollständig'] = 'Nein – Checkliste folgt per E-Mail';
        return;
      }
      if (value) properties[key] = value;
    });

    var nounterlagenEl = form.querySelector('#f-nounterlagen');
    if (nounterlagenEl && !nounterlagenEl.checked && type !== 'verkehrswert') {
      properties['Unterlagen vollständig'] = 'Ja, bereits vorhanden';
    }

    if (selectedFiles.length > 0) {
      properties['Hochgeladene Dateien'] = selectedFiles.map(function (f) {
        return f.name + ' (' + formatSize(f.size) + ')';
      }).join(', ');
    }

    properties['Gutachten-Typ'] = prodTitleEl ? prodTitleEl.value : 'Unbekannt';

    // Build email notification body
    var productTitle = (prodTitleEl && prodTitleEl.value) ? prodTitleEl.value : 'Gutachten';
    var emailBody = 'Neue Anfrage: ' + productTitle + '\n\n';
    Object.keys(properties).forEach(function (k) { emailBody += k + ': ' + properties[k] + '\n'; });
    if (selectedFiles.length > 0) {
      emailBody += '\nHochgeladene Dateien: ' + selectedFiles.map(function (f) { return f.name; }).join(', ');
    }

    var customerEmail = (form.querySelector('#f-email') && form.querySelector('#f-email').value)
      ? form.querySelector('#f-email').value : 'anfrage@immowerte24.de';
    var customerName = (form.querySelector('#f-name') && form.querySelector('#f-name').value)
      ? form.querySelector('#f-name').value : 'Kunde';

    var contactData = new URLSearchParams();
    contactData.append('form_type', 'contact');
    contactData.append('utf8', '\u2713');
    contactData.append('contact[email]', customerEmail);
    contactData.append('contact[name]', customerName + ' \u2013 ' + productTitle);
    contactData.append('contact[body]', emailBody);

    // Verkehrswertgutachten: only send contact form, no cart
    if (type === 'verkehrswert') {
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: contactData.toString()
      })
      .then(function () {
        setLoading(false);
        form.innerHTML = '<div class="contact__success" style="padding:2rem;text-align:center">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
          '<h3 style="margin-top:1rem">Vielen Dank!</h3>' +
          '<p>Ihre Anfrage ist bei uns eingegangen. Wir melden uns innerhalb von 24 Stunden mit einem individuellen Angebot.</p>' +
          '<button type="button" onclick="document.getElementById(\'order-modal\').hidden=true;document.body.style.overflow=\'\'" class="btn btn--primary" style="margin-top:1.5rem">Schließen</button>' +
          '</div>';
      })
      .catch(function () {
        setLoading(false);
        errorEl.textContent = 'Fehler beim Absenden. Bitte rufen Sie uns direkt an: 0611 98798881';
        errorEl.hidden = false;
      });
      return;
    }

    // All other products: add to cart, then send notification, then checkout
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(varIdEl.value), quantity: 1, properties: properties })
    })
    .then(function (resp) {
      if (!resp.ok) throw new Error('cart_add_failed');
      return resp.json();
    })
    .then(function () {
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: contactData.toString()
      }).catch(function () { /* ignore */ });
      window.location.href = '/checkout';
    })
    .catch(function () {
      setLoading(false);
      errorEl.textContent = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.';
      errorEl.hidden = false;
    });
  });
})();

// ── FAQ accordion ──
(function () {
  document.querySelectorAll('.faq__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = this.closest('.faq__item');
      var isOpen = item.classList.contains('faq__item--open');
      document.querySelectorAll('.faq__item--open').forEach(function (el) { el.classList.remove('faq__item--open'); });
      if (!isOpen) item.classList.add('faq__item--open');
    });
  });
})();
